<script lang="ts">
	// Genuine shadcn-svelte Select.Content (bits-ui), RESTYLED to price-check tokens.
	// Entry/exit animation utilities (which need a tailwindcss-animate plugin we
	// don't ship) and the anchor-size arbitrary values are dropped; the menu sizes
	// to its content with a scrollable max height. NO arbitrary `[..]` values.
	import { Select as SelectPrimitive } from "bits-ui";
	import SelectPortal from "./select-portal.svelte";
	import SelectScrollUpButton from "./select-scroll-up-button.svelte";
	import SelectScrollDownButton from "./select-scroll-down-button.svelte";
	import { cn, type WithoutChild } from "../../../utils.js";
	import type { ComponentProps } from "svelte";
	import type { WithoutChildrenOrChild } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		sideOffset = 4,
		portalProps,
		children,
		preventScroll = true,
		...restProps
	}: WithoutChild<SelectPrimitive.ContentProps> & {
		portalProps?: WithoutChildrenOrChild<ComponentProps<typeof SelectPortal>>;
	} = $props();
</script>

<SelectPortal {...portalProps}>
	<SelectPrimitive.Content
		bind:ref
		{sideOffset}
		{preventScroll}
		data-slot="select-content"
		class={cn(
			"relative isolate z-50 max-h-96 min-w-36 overflow-x-hidden overflow-y-auto rounded-md border border-border bg-surface text-ink shadow-md",
			className
		)}
		{...restProps}
	>
		<SelectScrollUpButton />
		<SelectPrimitive.Viewport class={cn("w-full scroll-my-1 p-1")}>
			{@render children?.()}
		</SelectPrimitive.Viewport>
		<SelectScrollDownButton />
	</SelectPrimitive.Content>
</SelectPortal>
